import React, { useState } from 'react';
import Layout from '@/components/Layout';
import Hero from '@/components/home/Hero';
import ProductGallery from '@/components/home/ProductGallery';
import FaceShapeGuide from '@/components/home/FaceShapeGuide';
import LensExplorer from '@/components/home/LensExplorer';
import CreatorPicks from '@/components/home/CreatorPicks';
import InfoSection from '@/components/home/InfoSection';
import CartDrawer from '@/components/cart/CartDrawer';
import Toast from '@/components/common/Toast';
import { CartProvider } from '@/context/CartContext';

const Home = () => {
  const [toast, setToast] = useState({ visible: false, message: '' });

  const showToast = (message) => setToast({ visible: true, message });

  return (
    <CartProvider>
      <Layout>
        <Hero />
        <ProductGallery />
        <FaceShapeGuide />
        <LensExplorer />
        <CreatorPicks />
        <InfoSection onNewsletterSuccess={() => showToast('WELCOME TO THE SPECTRUM')} />
        <CartDrawer />
        <Toast 
          isVisible={toast.visible} 
          message={toast.message} 
          onClose={() => setToast({ ...toast, visible: false })} 
        />
      </Layout>
    </CartProvider>
  );
};

export default Home;